import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'controlbar',
    styles: [
        `
            .controlbar {
                height: 25px;
                display: -webkit-flex;
                display: flex;
                -webkit-justify-content: flex-end;
                justify-content: flex-end;
                opacity: 0.7;
                transition: opacity 0.2s;
            }

            .controlbar:hover {
                opacity: 1;
            }

            .button {
                cursor: pointer;
                border: 0;
                margin: 0;
                opacity: 0.5;
                transition: opacity 0.2s ease-out;
                padding: 5px 7px 4px;
                margin-left: 2px;
                width: 30px;
                height: 30px;
            }

            .button .icon {
                font-size: 16px;
                max-height: 16px;
                max-width: 16px;
            }

            .button:hover {
                opacity: 1;
            }

            .close-button {
                height: 30px;
                padding-right: 2px;
            }

            .close-button:hover {
                background-color: #c62828 !important;
            }
        `,
    ],
    template: `
        <div class="controlbar">
            @if (canMinimize) {
                <button
                    class="button themedIcon"
                    (click)="minimizeClicked()"
                    Title="Minimize"
                >
                    <span class="icon xm-icon-minimize"></span>
                </button>
            }
            @if (canMaximize && maximized) {
                <button
                    class="button themedIcon"
                    (click)="restoreClicked()"
                    Title="Restore"
                >
                    <span class="icon xm-icon-restore"></span>
                </button>
            }
            @if (canMaximize && !maximized) {
                <button
                    class="button themedIcon"
                    (click)="maximizeClicked()"
                    Title="Maximize"
                >
                    <span class="icon xm-icon-maximize"></span>
                </button>
            }
            <div class="close-button">
                <button class="button" (click)="closeClicked()" Title="Close">
                    <span class="icon dx-icon-close"></span>
                    <!--<img class="icon" src="../../Content/icons/Close.svg" />-->
                </button>
            </div>
        </div>
    `,
    standalone: false,
})
export class Controlbar {
    @Input() canMinimize: boolean = true;
    @Input() canMaximize: boolean = true;
    @Input() maximized: boolean = false;
    @Output() close = new EventEmitter();
    @Output() minimize = new EventEmitter();
    @Output() maximize = new EventEmitter();
    @Output() restore = new EventEmitter();

    minimizeClicked() {
        this.minimize.emit();
    }

    maximizeClicked() {
        this.maximized = true;
        this.maximize.emit();
    }

    restoreClicked() {
        this.maximized = false;
        this.restore.emit();
    }

    closeClicked() {
        this.close.emit();
    }
}
